/**
 * Created by Ewald Stamp (ewald.stamp@netmills.de) on 05.03.15.
 */

angular.module('farmnet.partner.fendt').service('fendtVarioDocService', [
  'fendtVarioDocHttp',
  function(fendtVarioDocHttp) {
    'use strict';

    /**
     * 'Plan' the booking operation with the given id.
     * The Fendt Bundle will send the operation data
     * to VarioDoc.
     * @param {String} operationId
     * UUID of booking operation
     * @returns {ng.Promise}
     */
    this.plan = function(operationId) {
      return fendtVarioDocHttp.plan(operationId).then(function(result) {
        return result.data;
      });
    };

    /**
     * Check if a machine with the given serial number
     * is registered with VarioDoc.
     * @param {String} serial
     * @returns {ng.Promise}
     */
    this.isRegistered = function(serial) {
      return fendtVarioDocHttp.isRegistered(serial).then(function(result) {
        return result.data;
      });
    };
  }
]);
